module.exports = __webpack_public_path__ + "img/montournoi.6adbee1e.png";